export const IMG_ID = 'app__loading__img'
export const TEXT_ID = 'app__loading__text'
export const IMG_CLASSES = [
  'logo--transparent-stroke',
  'logo--dashed',
]
